import axios from "axios";

const address = process.env.NEXT_PUBLIC_API_URL;

export const uploadMlFile = (file, token) => {
	let headers = { "Content-Type": "application/form-data" };

	if (token) { headers = { "Content-Type": "application/form-data", Authorization: `Bearer ${token}` }; }

	let formData = new FormData();

	formData.append("file", file);

	return axios.post(`${address}/v1/assets/`, formData, { headers: headers });
};

export const createMlJob = (token, jobData) => {
	let headers = { "Content-Type": "application/json" };

	if (token) { headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` }; }

	let formData = new FormData();

	for (let key in jobData) {
		formData.append(key, jobData[key]);
	}

	return axios.post(`${address}/v1/mljobs/ `, formData, { headers: headers });
};

export const getMlJobStatus = (job_id) => {
	return axios.get(`${address}/v1/mljobs/${job_id}/`);
};

export const getInteriorStyles = () => {
	return axios.get(`${address}/v1/interiors/styles/`);
};

export const getInteriorRooms = () => {
	return axios.get(`${address}/v1/interiors/rooms/`);
};

export const saveMlResultToGallery = ({ token, id }) => {
	let headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
	return axios.post(`${address}/v1/mltasks/${id}/save/`, {}, { headers: headers });
};
